module.exports = __webpack_public_path__ + "static/media/speaker_mobile.c9424982.png";